/** Characters that make a spreadsheet treat a cell as a formula (CSV injection). */
const FORMULA_PREFIXES = ["=", "+", "-", "@"] as const;

/**
 * Prefix formula-leading or control-prefixed text so Excel/Sheets does not execute it.
 * Matches workspace overview `textCell` plus leading tab/CR (Igor AD-3049).
 */
export function guardCsvFormulaInjection(value: string): string {
  if (/^[\t\r]/.test(value)) {
    return `'${value}`;
  }
  const trimmed = value.trimStart();
  if (FORMULA_PREFIXES.some((prefix) => trimmed.startsWith(prefix))) {
    return `'${value}`;
  }
  return value;
}

export function formatCsvExportCell(value: string | number | null | undefined): string {
  if (value == null) {
    return escapeCsvField("");
  }
  if (typeof value === "number") {
    return escapeCsvField(String(value));
  }
  return escapeCsvField(guardCsvFormulaInjection(value));
}

/** Quote a field when it would break the row; normalize CR for consistent parsing. */
export function escapeCsvField(value: string): string {
  const clean = value.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  if (!clean.includes('"') && !clean.includes(",") && !clean.includes("\n")) {
    return clean;
  }
  return `"${clean.replaceAll('"', '""')}"`;
}
